module.exports = __webpack_public_path__ + "img/home-06-compare-02.33b7e817.jpg";